<template>
    <div
        class="vehicle-type-selector"
        :class="{
            'vehicle-type-selector--horizontal': mode === 'horizontal',
            'vehicle-type-selector--primary': variant === 'primary',
        }"
    >
        <div
            v-for="type in availableTypes"
            :key="type"
            class="vehicle-type-selector__item vehicle-type"
            :class="{ 'is-selected': value === type }"
            @click="select(type)"
        >
            <div class="vehicle-type__button">
                <svg-icon class="vehicle-type__icon" :name="type" />
            </div>
            <div class="vehicle-type__label">
                {{ $tc(`common.${type}_capitalized`, 1) }}
            </div>
        </div>
    </div>
</template>
<script>
import {
    ASSET_SUB_TYPE_MOTORHOME,
    ASSET_SUB_TYPE_CAMPERVAN,
    ASSET_SUB_TYPE_CARAVAN,
    ASSET_SUB_TYPE_OTHER_CAMPER,
} from '~/config/assetTypes';

export default {
    props: {
        value: {
            type: String,
            default: null,
        },
        otherTypeIncluded: {
            type: Boolean,
            default: false,
        },
        mode: {
            type: String,
            default: '',
            validator: value => ['', 'horizontal'].includes(value),
        },
        variant: {
            type: String,
            default: '',
            validator: value => ['', 'primary'].includes(value),
        },
    },
    computed: {
        availableTypes() {
            return this.otherTypeIncluded
                ? [
                      ASSET_SUB_TYPE_MOTORHOME,
                      ASSET_SUB_TYPE_CAMPERVAN,
                      ASSET_SUB_TYPE_CARAVAN,
                      ASSET_SUB_TYPE_OTHER_CAMPER,
                  ]
                : [ASSET_SUB_TYPE_MOTORHOME, ASSET_SUB_TYPE_CAMPERVAN, ASSET_SUB_TYPE_CARAVAN];
        },
    },
    methods: {
        select(type) {
            this.$emit('input', type);
        },
    },
};
</script>
<style lang="scss">
@import '@/sass/_variables.scss';

.vehicle-type-selector {
    &__item {
        margin-right: 15px;
    }

    @media screen and (max-width: $bp-md-min) {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;

        &__item {
            flex-basis: calc(50% - 8px);
            margin-right: 0;
            border-radius: $default-border-radius;
            padding: 8px 0;
            background: $gray-light;

            &.is-selected {
                background-color: $secondary-color;
            }
        }
    }

    &--horizontal {
        display: flex;
        gap: 4px;

        @include lg {
            gap: 8px;
        }

        .vehicle-type-selector__item {
            padding: 10px;
            border-radius: $default-border-radius;
            margin: 0;

            @include lg {
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }

        .vehicle-type {
            &__label {
                @include font-size(14px);

                @include lg {
                    font-weight: 600;
                }
            }

            &__icon {
                width: 46px;
                height: 32px;

                @include lg {
                    width: 57px;
                    height: 40px;
                }
            }

            &__button {
                margin-bottom: 0;
            }
        }
    }

    &--primary {
        .vehicle-type-selector__item {
            background: $white;
            border: 1px solid $secondary-dark;

            &.is-selected {
                background-color: $secondary-color;
            }
        }

        .vehicle-type__button {
            background: none;
        }
    }
}

.vehicle-type {
    display: inline-block;
    text-align: center;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;

    &:focus-visible {
        outline: none;
    }

    &__button {
        display: inline-block;
        background: $gray-light;
        padding: 4px 10px;
        border-radius: $default-border-radius;
        margin-bottom: 5px;

        .is-selected & {
            background-color: $secondary-color;
        }
    }

    &__icon {
        width: 60px;
        height: 43px;
    }

    &__label {
        @include font-size(16px);
    }
}
</style>
